import { useModal } from '../../../containers/ModalContext';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { CssModuleType } from '@utils/cssModules';

import currentCssModule from './Availability.module.scss';
import AvailabilityModal from '../../../components/AvailabilityModal';

import { AvailibilityOption } from '../../../types';

interface AvailabilityProps extends React.PropsWithChildren<any> {
    filteredAvailabilityOptions: string[];
    availabilityOptions: AvailibilityOption[];
    handleAvailabilityOptions: (options: string[]) => void;
}

const Availability: React.FC<AvailabilityProps> = ({
    filteredAvailabilityOptions,
    availabilityOptions,
    handleAvailabilityOptions
}) => {
    const st: CssModuleType = currentCssModule;
    const { t } = useTranslation();
    const { showModal } = useModal();

    return (
        <div className={st.availability}>
            <label>{t('/Search/Availability')}</label>
            <button
                onClick={() =>
                    showModal(
                        `availability-modal`,
                        <AvailabilityModal
                            modalId={'availability-modal'}
                            filteredAvailabilityOptions={filteredAvailabilityOptions}
                            availabilityOptions={availabilityOptions}
                            handleAvailabilityOptions={
                                handleAvailabilityOptions
                            }
                        />
                    )
                }
            >
                {!filteredAvailabilityOptions?.length
                    ? 'Choose availability options'
                    : ''}
                {!!availabilityOptions?.length && filteredAvailabilityOptions?.map(
                    (fao, ind) => {
                        const option = availabilityOptions.find(ao => ao.value === fao); 
                        if (!option) return '';
                        return `${option.display_name} (${option.count}) ${
                            filteredAvailabilityOptions.length - 1 !== ind
                                ? ' • '
                                : ''
                        }`
                    }
                )}
            </button>
        </div>
    );
};

export default Availability;
